(function () {
    if (!window.blCustomDrawerInit) {
        window.blCustomDrawerInit = true;

        window.blCustomOpenDrawer = function (id) {
            // Discard any unconfirmed pending picks when the drawer closes
            document.getElementById(id).querySelectorAll('.bl-custom-size-btn.bl-custom-select').forEach(function (b) {
                b.classList.remove('bl-custom-select');
            });
            updateConfirmBtn();
            var drawer = document.getElementById(id);
            var overlay = document.getElementById(id + '-overlay');
            if (drawer) drawer.classList.add('bl-custom-open');
            if (overlay) overlay.classList.add('bl-custom-open');
            document.body.style.overflow = 'hidden';
            var formWrapper = document.querySelector('.form__wrapper');
            if (formWrapper) formWrapper.style.zIndex = '6000';
        };

        window.blCustomCloseDrawer = function (id) {
            document.body.classList.remove('bl-chat-active');
            var drawer = document.getElementById(id);
            var overlay = document.getElementById(id + '-overlay');
            if (drawer) {
                drawer.classList.remove('bl-custom-open');
                // Reset scroll position so it reopens at the top
                var body = drawer.querySelector('.bl-custom-drawer-body');
                setTimeout(function () {
                    if (body) body.scrollTop = 0;
                }, 50);

            }
            if (overlay) overlay.classList.remove('bl-custom-open');
            document.body.style.overflow = '';
            setTimeout(function () {
                var formWrapper = document.querySelector('.form__wrapper');
                if (formWrapper) formWrapper.style.zIndex = '0';
            }, 100);
        };
    }

    // ── Module-scoped state (shared across init + globally exposed functions) ──
    var totalOptions;
    var selections;
    var selectSizeBtn;
    var atcBtn;
    var sizeRowsWrap;
    var confirmBtn;

    // ── Helpers ──────────────────────────────────────────────

    function checkAllSelected() {
        var selectedCount = Object.keys(selections).length;
        var allSelected = selectedCount >= totalOptions;

        if (selectSizeBtn) selectSizeBtn.style.display = allSelected ? 'none' : '';
        if (atcBtn) atcBtn.style.display = allSelected ? '' : 'none';
        if (sizeRowsWrap) {
            sizeRowsWrap.querySelectorAll('.bl-custom-variant-row').forEach(function (row) {
                var labelSpan = row.querySelector('[data-bl-custom-option-index]');
                if (labelSpan) {
                    var optionIndex = parseInt(labelSpan.dataset.blCustomOptionIndex);
                    if (selections.hasOwnProperty(optionIndex)) {
                        labelSpan.textContent = selections[optionIndex];
                        labelSpan.classList.remove('bl-custom-value--placeholder');
                    } else {
                        labelSpan.textContent = 'Select';
                        labelSpan.classList.add('bl-custom-value--placeholder');
                    }
                }
            });
        }
        var mobileSizeBtn = document.getElementById('bl-sticky-mobile-size-btn');
        if (mobileSizeBtn) {
            if (window.blStickyUpdateMobileBtn) window.blStickyUpdateMobileBtn(selections);
        }
    }

    function updateConfirmBtn() {
        if (!confirmBtn) return;
        var grids = document.querySelectorAll('.bl-custom-size-grid');
        var allActive = true;
        grids.forEach(function (grid) {
            if (!grid.querySelector('.bl-custom-size-btn.bl-custom-select, .bl-custom-size-btn.bl-custom-active')) {
                allActive = false;
            }
        });
        confirmBtn.disabled = !allActive;
    }

    function selectionsToArray(sel) {
        var optionCount = document.querySelectorAll('[data-bl-custom-option-index]').length;
        var arr = [];
        for (var i = 0; i < optionCount; i++) {
            arr.push(sel[i]);
        }
        return arr;
    }

    function findVariant(opts) {
        return (window.blProductVariants || []).find(function (v) {
            return opts.every(function (o, i) { return v.options[i] === o; });
        });
    }

    function formatPrice(cents) {
        if (window.Shopify && Shopify.formatMoney) {
            return Shopify.formatMoney(cents, window.blMoneyFormat || "${{amount}}");
        }
        return '$' + (cents / 100).toFixed(2);
    }

    function updateMainAddToCartPrice() {
        var opts = selectionsToArray(selections);

        // bail if any option still unselected
        if (opts.some(function (v) { return v === undefined; })) return;

        var matchedVariant = findVariant(opts);
        if (!matchedVariant) return;

        var priceEls = document.querySelectorAll('.product__submit__buttons .bt-pric');
        priceEls.forEach(function (priceEl) {
            priceEl.textContent = formatPrice(matchedVariant.price);
        });

        if (!atcBtn) return;

        atcBtn.disabled = !matchedVariant.available;
        atcBtn.dataset.variantId = matchedVariant.id;
    }

    // ── Globally callable confirm logic ─────────────────────
    window.blConfirmSizeSelection = function () {
        document.querySelectorAll('.bl-custom-size-btn.bl-custom-select').forEach(function (btn) {
            var optionIndex = parseInt(btn.dataset.optionIndex);
            var value = btn.dataset.sizeValue;

            btn
                .closest('.bl-custom-size-grid')
                .querySelectorAll('.bl-custom-size-btn')
                .forEach(function (b) {
                    b.classList.remove('bl-custom-active');
                });
            btn.classList.add('bl-custom-active');
            btn.classList.remove('bl-custom-select');
            // Update label
            var label = document.querySelector('[data-bl-custom-option-index="' + optionIndex + '"]');
            if (label) label.textContent = value;

            // Save to selections
            selections[optionIndex] = value;
            updateConfirmBtn();
            // Sync main page
            var targetOption = document.querySelector(
                '[data-popout-option][data-option-index="' + optionIndex + '"][data-value="' + CSS.escape(value) + '"]'
            );
            if (targetOption) {
                targetOption.click();
            } else {
                var hiddenInput = document.querySelector(
                    '[data-popout-input][data-index="option' + (optionIndex + 1) + '"]'
                );
                if (hiddenInput) {
                    hiddenInput.value = value;
                    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });

        checkAllSelected();
        // updateMainAddToCartPrice();
        window.blCustomCloseDrawer('size-drawer');
    };
    window.blConfirmSizeSelectionSticky = function () {
        document.querySelectorAll('.bl-custom-size-btn.bl-custom-active').forEach(function (btn) {
            var optionIndex = parseInt(btn.dataset.optionIndex);
            var value = btn.dataset.sizeValue;
            var label = document.querySelector('[data-bl-custom-option-index="' + optionIndex + '"]');
            if (label) label.textContent = value;

            // Save to selections
            selections[optionIndex] = value;
            updateConfirmBtn();
            var targetOption = document.querySelector(
                '[data-popout-option][data-option-index="' + optionIndex + '"][data-value="' + CSS.escape(value) + '"]'
            );
            if (targetOption) {
                targetOption.click();
            } else {
                var hiddenInput = document.querySelector(
                    '[data-popout-input][data-index="option' + (optionIndex + 1) + '"]'
                );
                if (hiddenInput) {
                    hiddenInput.value = value;
                    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });
        // updateMainAddToCartPrice();
        checkAllSelected();
    };

    // ── Init ─────────────────────────────────────────────────
    function init() {
        document.querySelectorAll('[data-drawer="colour-drawer"], [data-drawer="fabric-drawer"], [data-drawer="size-drawer"]').forEach(function (btn) {
            if (btn.dataset.blDrawerBound) return;
            btn.dataset.blDrawerBound = 'true';
            btn.addEventListener('click', function () {
                window.blCustomOpenDrawer(btn.dataset.drawer);
            });
        });

        document.querySelectorAll('[data-close]').forEach(function (btn) {
            if (btn.dataset.blCloseBound) return;
            btn.dataset.blCloseBound = 'true';
            btn.addEventListener('click', function () {
                window.blCustomCloseDrawer(btn.dataset.close);
            });
        });

        document.querySelectorAll('.bl-custom-drawer-overlay').forEach(function (overlay) {
            if (overlay.dataset.blOverlayBound) return;
            overlay.dataset.blOverlayBound = 'true';
            overlay.addEventListener('click', function () {
                window.blCustomCloseDrawer(overlay.id.replace('-overlay', ''));
            });
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                document.querySelectorAll('.bl-custom-drawer.bl-custom-open').forEach(function (d) {
                    window.blCustomCloseDrawer(d.id);
                });
            }
        });

        totalOptions = document.querySelectorAll('.bl-custom-size-section').length;
        selections = {};
        selectSizeBtn = document.querySelector('.bl-custom-select-size-trigger');
        atcBtn = document.querySelector('.bl-custom-add-to-cart-trigger');
        sizeRowsWrap = document.querySelector('.bl-custom-size-rows-wrap');
        confirmBtn = document.querySelector('.confirm-selection-btn');

        document.querySelectorAll('.bl-custom-size-btn.bl-custom-active').forEach(function (btn) {
            selections[parseInt(btn.dataset.optionIndex)] = btn.dataset.sizeValue;
        });

        checkAllSelected();

        document.querySelectorAll('.bl-custom-size-btn').forEach(function (btn) {
            if (btn.dataset.blSizeBound) return;
            btn.dataset.blSizeBound = 'true';

            // AFTER
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (btn.classList.contains('bl-custom-soldout')) return;

                var wasSelected = btn.classList.contains('bl-custom-select');

                btn
                    .closest('.bl-custom-size-grid')
                    .querySelectorAll('.bl-custom-size-btn')
                    .forEach(function (b) {
                        b.classList.remove('bl-custom-select');
                    });

                if (!wasSelected) {
                    btn.classList.add('bl-custom-select'); // pending, not confirmed yet
                }

                updateConfirmBtn();
            });
        });

        updateConfirmBtn();

        // ── Confirm button Click ──
        if (confirmBtn && !confirmBtn.dataset.blConfirmBound) {
            confirmBtn.dataset.blConfirmBound = 'true';
            confirmBtn.addEventListener('click', function () {
                window.blConfirmSizeSelection();
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('click', function (e) {
        if (!e.target || typeof e.target.closest !== 'function') return;
        var link = e.target.closest('a');
        if (!link) return;
        
        // Exclude 'Find your size' / size chart modal triggers
        if (link.matches('[data-popup-open], .radio__legend__link') || link.closest('product-modal')) return;

        var dmWrapper = link.closest('.dm-link, .bl-custom-pdp-dm-text');
        if (!dmWrapper) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        document.body.classList.add('bl-chat-active');

        var shopifyChat = document.querySelector('shopify-chat');
        if (shopifyChat) {
            shopifyChat.classList.add('is-chat-open');
            shopifyChat.style.setProperty('opacity', '1', 'important');
            shopifyChat.style.setProperty('visibility', 'visible', 'important');
            shopifyChat.style.setProperty('pointer-events', 'none', 'important');
            shopifyChat.style.setProperty('z-index', '2147483647', 'important');

            if (shopifyChat.shadowRoot) {
                var wrapper = shopifyChat.shadowRoot.querySelector('#shopify-element-wrapper');
                if (wrapper) {
                    wrapper.style.setProperty('pointer-events', 'auto', 'important');
                }
            }
        }

        if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
            try {
                window.ShopifyChat.open();
            } catch (err) {}
        }

        try {
            if (!shopifyChat || !shopifyChat.shadowRoot) return;

            var shadowRoot = shopifyChat.shadowRoot;
            var chatTrigger = shadowRoot.querySelector("#shopify-element-wrapper .activator");
            if (chatTrigger) {
                chatTrigger.click();
            } else {
                var runtime = shadowRoot.querySelector("#shopify-element-wrapper shopify-agent-runtime");
                var runtimeTrigger = runtime && runtime.shadowRoot ? runtime.shadowRoot.querySelector("#shopify-element-wrapper .activator") : null;
                if (runtimeTrigger) {
                    runtimeTrigger.click();
                }
            }
        } catch (err) {
            console.error("Error launching Shopify Chat:", err);
        }
    }, true);

})();